export const communityConst = {
    BODY_MAX_LENGTH: 5000
}
